import type { FC } from 'react'
import { Box, Typography } from '@mui/material'
import { AddOutlined, ListOutlined } from '@mui/icons-material'
import { HostAdditionModal } from '@/features/host-registration'
import { useDialog } from '@/common/hooks'
import { HostsListModal } from './HostsListModal'
import {
  actionButtonSx,
  actionGroupSx,
  buttonLabelSx,
  contentSx,
  iconSx,
  sectionDescriptionSx,
  sectionTitleSx,
} from './settingsSectionStyles'

export const HostIdentitiesSection: FC = () => {
  const registerModal = useDialog()
  const listModal = useDialog()

  return (
    <>
      <Box>
        <Typography variant="body1" sx={sectionTitleSx}>
          Registered Hosts
        </Typography>
        <Box sx={contentSx}>
          <Typography variant="body2" sx={sectionDescriptionSx}>
            Register host to prompt remote agent instances.
          </Typography>
          <Box sx={actionGroupSx}>
            <Box
              component="button"
              onClick={listModal.open}
              sx={actionButtonSx}
              aria-label="View registered hosts"
            >
              <ListOutlined sx={iconSx} aria-hidden="true" />
              <Typography variant="body2" sx={buttonLabelSx}>
                View
              </Typography>
            </Box>
            <Box
              component="button"
              onClick={registerModal.open}
              sx={actionButtonSx}
              aria-label="Register host"
            >
              <AddOutlined sx={iconSx} aria-hidden="true" />
              <Typography variant="body2" sx={buttonLabelSx}>
                Register
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      <HostAdditionModal open={registerModal.isOpen} onClose={registerModal.close} />
      <HostsListModal open={listModal.isOpen} onClose={listModal.close} />
    </>
  )
}
